import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICategory } from "src/models/Products/Category.models";

interface CategoryState {
  categories: ICategory[];
  categoryToEdit: ICategory | null;
}

const initialState: CategoryState = {
  categories: [],
  categoryToEdit: null,
};

const CategorySlice = createSlice({
  name: "Category",
  initialState,
  reducers: {
    setCategoryList: (state, action: PayloadAction<ICategory[]>) => {
      state.categories = action.payload;
    },
    concatListCategory: (
      state: CategoryState,
      action: PayloadAction<ICategory[]>
    ) => {
      state.categories = [...state.categories.concat(action.payload)];
    },
    setCategoryToEdit: (state, action: PayloadAction<ICategory | null>) => {
      state.categoryToEdit = action.payload;
    },
    addCategory: (state, action: PayloadAction<ICategory>) => {
      state.categories.push(action.payload);
    },
    addCategories: (state, action: PayloadAction<ICategory[]>) => {
      state.categories.push(...action.payload);
    },
    updateCategory: (state, action: PayloadAction<ICategory>) => {
      let itemIndex = state.categories.findIndex(
        item => item.categoryId === action.payload.categoryId
      );
      if (itemIndex !== -1) state.categories[itemIndex] = action.payload;
    },
    deleteCategory: (state, action: PayloadAction<number>) => {
      const newArray = state.categories.filter(
        item => item.categoryId !== action.payload
      );
      state.categories = newArray;
    },
  },
});

export const {
  setCategoryList,
  concatListCategory,
  setCategoryToEdit,
  addCategory,
  addCategories,
  updateCategory,
  deleteCategory,
} = CategorySlice.actions;

export default CategorySlice.reducer;
